import { z } from 'zod';

import { HcoSchema } from '@/core/graphql/generated/validation.zod';
import { emailValidator } from '@/utils/validators/zod/emailValidator';
import { websiteValidator } from '@/utils/validators/zod/websiteValidator';

export const ContactSectionSchema = () => {
	const raw = HcoSchema().pick({
		officePhoneCda_V: true,
		faxCda_V: true,
		emailCda_V: true,
		websiteCda_V: true
	});

	return z.object({
		// Note(Filip): As of 28.01.2026 - Jonas reqested this to be hidden for the time being
		// officePhoneCda_V: phoneNumberValidator(raw.shape.officePhoneCda_V),
		// faxCda_V: phoneNumberValidator(raw.shape.faxCda_V),

		emailCda_V: emailValidator(raw.shape.emailCda_V),

		websiteCda_V: websiteValidator(raw.shape.websiteCda_V)
	});
};

export type ContactSectionValuesIn = z.input<
	ReturnType<typeof ContactSectionSchema>
>;
export type ContactSectionValuesOut = z.output<
	ReturnType<typeof ContactSectionSchema>
>;
